import { useTranslation } from 'next-i18next';
import { CouponFillIcon } from '@/icons';
export const VoucherAvailableCount = ({
  count
}: {
  count: number;
}) => {
  const {
    t
  } = useTranslation(['billing']);
  return <div className="hidden min-w-[240px] items-center gap-sm rounded-md bg-default p-md tablet-sm:flex" data-sentry-component="VoucherAvailableCount" data-sentry-source-file="VoucherAvailableCount.tsx">
      <div className="flex size-[52px] items-center justify-center rounded-full bg-yellow-100">
        <CouponFillIcon size="lg" className="text-yellow-500" data-sentry-element="CouponFillIcon" data-sentry-source-file="VoucherAvailableCount.tsx" />
      </div>
      <div className="flex flex-1 flex-col gap-4xs">
        <span className="text-caption-lg-semibold text-alternative">
          {t('billing:voucher.usable')}
        </span>
        <span className="text-heading-xl-extrabold text-default">{count}</span>
      </div>
    </div>;
};